import styled from "styled-components";

export const Container = styled.div`
  min-height: 24px;
  margin: 8px auto;
  color: ${props => props.status === "ending" ? "#f44336":"#263238"};
`;